import { render, staticRenderFns } from "./project-houseType-view.vue?vue&type=template&id=5f2b01e3&scoped=true&"
import script from "./project-houseType-view.vue?vue&type=script&lang=js&"
export * from "./project-houseType-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b01e3",
  null
  
)

export default component.exports